import * as React from 'react'
import { ReactNode } from 'react'

import { Account } from '../../../models'

import styles from './AccountEntry.scss'

export interface Props {
  account: Account
  isCurrent: boolean
  onSelect: (acc: Account) => void
}

class AccountEntry extends React.PureComponent<Props> {

  public render (): ReactNode {
    const { account, isCurrent } = this.props
    let clsName = styles.account_entry
    if (isCurrent) {
      clsName += ` ${styles.selected}`
    }

    return (
        <div data-cy={`accountEntry_${account.id}`} className={clsName} onClick={this.handleClick}>
          <div data-cy="accountName">
            <a>{this.getAccountName(account.name)}</a>
          </div>
        </div>
    )
  }

  private handleClick = (): void => {
    return this.props.onSelect(this.props.account)
  }

  private getAccountName = (title): string => {
    if (title.length > 82) {
        let reducedStr = ''

        reducedStr += title.substr(0, 83)
        reducedStr += ' ... '

        return reducedStr
    }
    return title
  }

}

export default AccountEntry
